export function URLComponents(url) {
    let components = decodeURIComponent(url).split("/");
    // Trim leading slash
    if (components[0] == "")
        components.shift();
    // Allow trailing slash
    if (components[components.length - 1] == "")
        components.pop();
    // If the URL was only a single slash, we represent this as a single empty component
    if (components.length == 0)
        components.push("");
    return components;
}
